<template>
      <ul class="menu-container">
        <li
          v-for="item in items"
          :key="item.id"
          class="menu-item"
          :class="{ active: activeId === item.id }"
          @click="handleClick(item.id,item.name)"
        >
          {{ item.name }}
        </li>
      </ul>
  </template>
  
  <script setup>
  import { ref, defineProps, defineEmits } from 'vue';

  const props = defineProps({
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    initialActive: {
      type: [String, Number],
      default: null
    }
  });

  const emit = defineEmits(['select']);

  const activeId = ref(props.initialActive || (props.items[0]?.id || null));

  const handleClick = (id,name) => {
    activeId.value = id;
    emit('select', name);
  };
 
  </script>
  
  <style scoped>
.menu-container {
  display: flex;
    justify-content: space-around;
    padding: 0;
    margin: 0;
    background-color: #2660cc;
    margin:20px 0;
}

.menu-item {
  font-size: 14px;
    text-align: center;
    padding: 12px 5px;
    list-style: none;
    text-decoration: none;
    color: #c0d4f9;
    transition: all .3s ease;
}


.menu-item.active {
  color: black;
  background-color:  #fff;
}
  </style>